import RouterModel from "../../router/RouterModel.js";
import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";

import DaiEx from "./Export/DaiEx.vue";
import DaiP from "./Print/DaiP.vue";
import DaiR from "./Report/DaiR.vue";

export default {
  Path: {
    Main: RouterModel.getPath(AppModule.DailyReport),
    Print: RouterModel.getPath(AppModule.DailyReport, AppModuleType.Print),
    Export: RouterModel.getPath(AppModule.DailyReport, AppModuleType.Export)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.DailyReport, AppModuleType.Export),
        name: RouterModel.getName(AppModule.DailyReport, AppModuleType.Export),
        component: DaiEx,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.DailyReport, AppModuleType.Export),
          module: RouterModel.getModule(AppModule.DailyReport),
          moduleattr: AppModuleAttr.DailyReport_Act_Export,
          moduletype: AppModuleType.Export
        }
      },
      {
        path: RouterModel.getPath(AppModule.DailyReport),
        name: RouterModel.getName(AppModule.DailyReport),
        component: DaiR,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.DailyReport),
          module: RouterModel.getModule(AppModule.DailyReport),
          moduleattr: AppModuleAttr.DailyReport_Act_Report,
          moduletype: AppModuleType.Report,
          export: {
            module: RouterModel.getModule(AppModule.DailyReport),
            moduleattr: AppModuleAttr.DailyReport_Act_Export,
            moduletype: AppModuleType.Export
          },
          print: {
            module: RouterModel.getModule(AppModule.DailyReport),
            moduleattr: AppModuleAttr.DailyReport_Act_Print,
            moduletype: AppModuleType.Print
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.DailyReport, AppModuleType.Print),
        name: RouterModel.getName(AppModule.DailyReport, AppModuleType.Print),
        component: DaiP,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.DailyReport, AppModuleType.Print),
          module: RouterModel.getModule(AppModule.DailyReport),
          moduleattr: AppModuleAttr.DailyReport_Act_Print,
          moduletype: AppModuleType.Print
        }
      }
    ];
  }
}